import React from "react";
import { Handle, Position } from "reactflow";
import { useTranslation } from "../i18n/useTranslation";

function IntentNode({ data, selected }) {
  const t = useTranslation();
  const hasConnectedPrompt = data.hasConnectedPrompt || false;

  return (
    <div
      className={`
        w-[200px] rounded-lg bg-white shadow-lg overflow-hidden
        transition-all duration-200 ease-in-out
        hover:bg-gray-200 
        ${selected ? "ring-2 ring-blue-500 ring-opacity-70" : ""}
      `}
    >
      <div className="flex flex-col">
        <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-4 py-2">
          <div className="text-white text-sm font-medium">{t('intentNode.title')}</div>
        </div>
        
        <div className="p-4 space-y-2">
          <div className="text-sm text-gray-700">
            <span className="font-medium">Name: </span>
            {data.intent || t('intentNode.unnamedIntent')}
          </div>
          
          
          {data.intentDescription && (
            <div className="text-xs text-gray-500 line-clamp-3">
              <span className="font-medium">{t('intentNode.content')}: </span>
              {data.intentDescription}
            </div>
          )}
          
          {data.intentSpeak && !hasConnectedPrompt && (
            <div className="text-xs text-gray-500">
              <span className="font-medium">{t('intentNode.speak')}: </span>
              <br></br>
              {data.intentSpeak}
            </div>
          )}
          
          {data.intentForwardPhone && !hasConnectedPrompt && (
            <div className="text-xs text-gray-500">
              <span className="font-medium">{t('intentNode.forwardPhone')}: </span>
              <br></br>
              {data.intentForwardPhone}
            </div>
          )}
        </div>
      </div>

      <Handle
        id="a"
        type="target"
        position={Position.Top}
        className="w-3 h-3 rounded-full bg-blue-500 border-2 border-white -top-1.5"
      />
      <Handle
        id="b"
        type="source"
        position={Position.Bottom}
        className="w-3 h-3 rounded-full bg-blue-500 border-2 border-white -bottom-1.5"
      />
    </div>
  );
}

export default IntentNode;
